'use client';
import { Typography } from '@mui/material';
import type { EntityCountByLocation } from '@repo/supergraph/base/metadata/types';
import { overrideGeoTargetedTitle } from '../../../utils/geo-data';
import { useGeo } from '../GeoProvider';

type Props = {
  title: string;
  isGeoTargeted?: boolean;
  titleWithoutEntityCount?: string;
  excludeEntityCountFromTitle?: boolean;
  entityCountByLocation?: EntityCountByLocation;
  filteredEntityCount?: number;
  typographyProps?: React.ComponentProps<typeof Typography>;
};

export const GeoRoundupTitle: React.FC<Props> = ({ isGeoTargeted, typographyProps, ...rest }) => {
  const { regionCode } = useGeo();
  const title = isGeoTargeted ? overrideGeoTargetedTitle(rest, regionCode) : rest.title;

  return <Typography {...typographyProps}>{title}</Typography>;
};
